/*
 * @Author: masonzhou
 * @Date: 2024-01-19 09:15:57
 * @LastEditTime: 2024-02-07 18:29:58
 * @FilePath: \yl-cjsph-tms-operation-front\src\store\modules\permission.ts
 * @Description:
 */
import { defineStore } from 'pinia';
import { store } from '@/store';
import { cacheType } from './types';
import { constantMenus } from '@/router';
import {
  ascending,
  filterTree,
  filterChildrenTree,
  handleBtnList
} from '@/router/utils';
import { useUserStoreHook } from '@/store/modules/user';
import { message } from '@/utils/message';
import { $t } from '@/plugins/i18n';

export const usePermissionStore = defineStore({
  id: 'pure-permission',
  state: () => ({
    // 静态路由生成的菜单
    constantMenus,
    // 整体路由生成的菜单（静态、动态）
    wholeMenus: [],
    btnList: localStorage.getItem('btnList') || [],
    menuList: JSON.parse(localStorage.getItem('menuList')) || [],
    // 缓存页面keepAlive
    cachePageList: []
  }),
  actions: {
    /** 组装整体路由生成的菜单 */
    handleWholeMenus(routes: any[]) {
      const menuData = filterTree(ascending(this.constantMenus.concat(routes)));
      // // 过滤children长度为0的的目录
      this.wholeMenus = filterChildrenTree(menuData);
      if (!this.wholeMenus.length) {
        // debugger
        // 无权限 自动退出
        message($t('该用户无权限, 禁止登陆系统'), {
          type: 'error',
          duration: 3 * 1000
        });
        this.clearAllCachePage();
        useUserStoreHook().logOut();
        window.location.reload();
        return;
      }
      // this.wholeMenus = ascending(this.constantMenus.concat(routes));
      this.menuList = this.findMenuTypeC(routes);
      localStorage.setItem('menuList', JSON.stringify(this.menuList));
    },
    handleBtnList(routes: any[]) {
      this.btnList = handleBtnList(routes);
      localStorage.setItem('btnList', JSON.stringify(this.btnList));
    },
    findMenuTypeC(data: any) {
      const result: any = [];
      data.forEach((item: any) => {
        if (item.menuType === 2) {
          result.push(item);
        }
        if (item.children) {
          result.push(...this.findMenuTypeC(item.children));
        }
      });
      return result;
    },
    cacheOperate({ mode, name }: cacheType) {
      switch (mode) {
        case 'add':
          this.cachePageList.push(name);
          this.cachePageList = [...new Set(this.cachePageList)];
          break;
        case 'delete':
          // eslint-disable-next-line no-case-declarations
          const delIndex = this.cachePageList.findIndex(v => v === name);
          delIndex !== -1 && this.cachePageList.splice(delIndex, 1);
          break;
      }
    },
    /** 清空缓存页面 */
    clearAllCachePage() {
      this.wholeMenus = [];
      this.cachePageList = [];
    }
  }
});

export function usePermissionStoreHook() {
  return usePermissionStore(store);
}
